export default {
  notification: new Audio('/audio/notification.mp3')
}
